import { render, staticRenderFns } from "./PostEvidencePart.vue?vue&type=template&id=eadc5de2&scoped=true&"
import script from "./PostEvidencePart.vue?vue&type=script&lang=js&"
export * from "./PostEvidencePart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadc5de2",
  null
  
)

export default component.exports